const WEEKS_IN_YEAR = 52.1429;
export const yearsToWeeks = (years, roundResult = true) => {
  const result = years * WEEKS_IN_YEAR;
  return roundResult ? Math.round(result) : result;
};
